export const pageTitle = 'Schedule';
export const actionButton = {
  create: 'Create Schedule',
  generate: 'Generate Schedule Set',
  export: 'Export',
  upload: 'Upload',
};

export const cancelTitlePopupText = '';
export const cancelDescriptionPopupText = '';

export const postScheduleText = {
  loadingTitle: 'Harap tunggu',
  loadingDesc: 'Schedule sedang dibuat!',
  successText: 'Schedule berhasil dibuat!',
  failedTitle: 'Gagal membuat schedule',
  failedContentTitle: 'Jadwal bertabrakan!',
  failedContentDesc:
    'Jadwal ini bertabrakan dengan jadwal lain. Silakan pilih waktu yang tidak konflik dengan akun dan host yang telah ditugaskan pada jam tersebut.',
  failedPrimaryText: 'Perbaiki Jadwal',
  failedSecondaryText: 'Tutup',
  failedServerDescription: 'Terjadi kesalahan saat membuat schedule. Silakan coba lagi.',
};

export const patchScheduleText = {
  loadingTitle: 'Harap tunggu',
  loadingDesc: 'Schedule sedang diupdate!',
  successText: 'Schedule berhasil dibuat!',
  failedTitle: 'Gagal mengubah schedule',
  failedContentTitle: 'Jadwal bertabrakan!',
  failedContentDesc:
    'Jadwal ini bertabrakan dengan jadwal lain. Silakan pilih waktu yang tidak konflik dengan akun dan host yang telah ditugaskan pada jam tersebut.',
  failedPrimaryText: 'Perbaiki Jadwal',
  failedSecondaryText: 'Tutup',
  failedServerDescription: 'Terjadi kesalahan saat memperbarui schedule. Silakan coba lagi.',
};

export const deleteScheduleText = {
  loadingTitle: 'Harap tunggu',
  loadingDesc: 'Schedule sedang dihapus!',
  successText: 'Schedule berhasil dihapus!',
  failedText: 'Schedule gagal dihapus!',
};

export const viewTypeOptions = [
  { value: 3, label: '3 Days' },
  { value: 1, label: 'Day' },
];

export const filterFields = {
  brand: {
    label: 'Brand',
    placeholder: 'Pilih Brand',
  },
  account: {
    label: 'Account',
    placeholder: 'Pilih Account',
  },
  platform: {
    label: 'Platform',
    placeholder: 'Pilih Platform',
  },
  host: {
    label: 'Host',
    placeholder: 'Pilih Host',
  },
  studio: {
    label: 'Studio',
    placeholder: 'Pilih Studio',
  },
  operator: {
    label: 'Operator',
    placeholder: 'Pilih Operator',
  },
  area: {
    label: 'Area',
    placeholder: 'Pilih Area',
  },
};

export const importScheduleText = {
  successTitle: 'Berhasil mengunggah file',
  successText: 'Schedule berhasil dibuat!',
  buttonSuccessText: 'Lihat hasil schedule',
  failedTitle: 'Upload Schedule',
  failedContentTitle: 'Schedule Gagal Diupload',
  failedContentDesc: 'Lakukan download data untuk melihat data dan alasan gagal.',
  warningContentTitle: 'Sebagian Schedule Berhasil Diupload',
  warningContentDesc: 'Lakukan download data untuk melihat schedule yang gagal diupload.',
  failedPrimaryButtonText: 'Download Data',
  failedSecondaryButtonText: 'Lihat Schedule',
  successUploadSchedule: 'Schedule berhasil diupload',
  failedUploadSchedule: 'Schedule gagal diupload',
  successDownloadData: 'Berhasil Download Data Error Upload Schedule',
  errorUploadScheduleText: 'Gagal mengunggah schedule',
  errorUploadScheduleDesc: 'Terjadi kesalahan saat mengunggah data. Silakan periksa kembali file kamu dan coba lagi.',
  errorUploadScheduleDescServer: 'Terjadi kesalahan saat mengunggah data. Silakan periksa kembali file kamu dan coba lagi.',
};

export const exportScheduleText = {
  successExportScheduleText: 'Download file schedule berhasil',
  failedExportScheduleText: 'Download file schedule gagal!',
  loadingExportScheduleText: 'Sedang mendownload file schedule',
};

export const downloadTemplateText = {
  successDownloadTemplateText: 'Template berasil diunduh!',
  failedDownloadTemplateText: 'Template gagal diunduh!',
  loadDownloadTemplateTitleText: 'Sedang Mengunduh',
  loadDownloadTemplateDescText: 'Mohon tunggu hingga unduhan berhasil',
};

export const scheduleAlertText = {
  title: 'Terdapat {numScheduleWarnings} jadwal tanpa Host',
  description: 'Beberapa host telah dinonaktifkan. Segera tetapkan host pengganti untuk jadwal tersebut.',
  changeHostButton: 'Atur Jadwal',
};

export const detailScheduleText = {
  noActiveHostAlert: (count) => `Terdapat ${count} jadwal tanpa host pada sesi ini`,
  noActiveHostBadgeText: 'Host tidak tersedia',
};
